import { memo, useState } from "react";
import { CameraOutlined } from "@ant-design/icons";
import { Grid } from "@mui/material";
import {
  Button as ButtonAntd,
  ConfigProvider,
  Image,
  Input,
} from "antd";
import { CameraComponentExporBananas } from "./camera-component";
import noImg from "../../../../images/no-image.png";

interface ItemPropsI {
  handleClose?: () => void;
  handleOpen?: () => void;
  value: string|null;
  setValue: (value: string) => void;
  open?: boolean;
  foto?: string;
  setFoto?: (foto: string) => void;
  label: string;
  labelFull?: string;
  placeholder?: string;
  noPhoto?: boolean;
  block?: boolean;
  numeric?: boolean;
  uuid?:string;
  labelSize?:number;
}

export const ItemElementBlur = memo(
  ({
    handleClose,
    handleOpen,
    value,
    setValue,
    open,
    foto,
    setFoto,
    label,
    placeholder = "",
    labelFull = "",
    noPhoto,
    block,
    numeric,
    uuid,
    labelSize=10,
  }: ItemPropsI) => {

    const [elValue, setElValue] = useState(value);

    return (
      <Grid
        container
        spacing={0.5}
        justifyContent="center"
        alignContent="center"
        alignItems="center"
      >
        <Grid
          item
          xs={noPhoto ? 12 : 10}
          sm={noPhoto ? 12 : 11}
          sx={{ display: "flex", justifyContent: "center" }}
        >
          <ConfigProvider
            theme={{
              components: {
                Input: {
                  addonBg: "#030521",
                  inputFontSize: 10,
                  inputFontSizeLG: 10,
                  inputFontSizeSM: 9,
                  paddingBlock:8.1,
                  paddingBlockLG:8.1,
                  paddingBlockSM:9.1,

                },
              },
            }}
          >
            <Input
              addonBefore={
                <p style={{ fontSize: labelSize, width: 100, color: "white", fontWeight: "bolder", textWrap: "wrap" }}>
                  {label}
                </p>
              }
              addonAfter={
                noPhoto ? null : (
                  <ButtonAntd
                    onClick={handleOpen}
                    type="text"
                    style={{color:"white"}}
                    icon={<CameraOutlined />}
                  />
                )
              }
              size="large"
              type={numeric ? "number" : "text"}
              placeholder={placeholder}
              style={{ width: "100%" }}
              value={elValue || ""}
              allowClear
              count={{
                max: 255,
                show:true,
              }}
              onChange={(e) => {
                setElValue(e.target.value);
              }}
              onBlur={(e) => {
                setValue(elValue!);
              }}
            />
          </ConfigProvider>
        </Grid>
        {noPhoto ? null : (
          <Grid item sx={{ display: "flex", justifyContent: "center" }}>
            <Image
              src={foto === "" ? noImg : foto}
              style={{
                width: 36,
                height: 36,
                borderRadius: 5,
                boxShadow: "0px 10px 15px 0px rgba(0,0,0,0.1)",
              }}
            />
            <CameraComponentExporBananas
              open={open!}
              handleClose={handleClose!}
              setFoto={setFoto!}
            />
          </Grid>
        )}
      </Grid>
    );
  }
);
